<template>
    <el-input
        v-model="phone"
        placeholder="Enter Mobile Number"
        class="input-with-select"
        @input="validate()"
    >
        <template #prepend>
            <el-select v-model="country" placeholder="Select" style="width: 100px" @change="validate()" filterable>
                <el-option v-for="country in countries"  :value="country.code" >
                    <template #tag>
                        +{{country.code}}
                    </template>
                    +{{country.code}} - {{country.name}}
                </el-option>

            </el-select>
        </template>

    </el-input>
</template>

<script>
import {
    ElInput,ElSelect,ElOption,ElButton
} from 'element-plus'
import {
    parsePhoneNumberFromString,
    AsYouType,
     CountryCode,
    getCountries,
    getCountryCallingCode,
    getExampleNumber,
    isSupportedCountry,
     Examples,
    parsePhoneNumber
} from 'libphonenumber-js'

let phoneNumber;


export default {
    name: "CountryPhone",
    components: { ElInput,ElSelect,ElOption,ElButton },
    emits: ["change"],
    props: {
        modelValue: {
            type: String,
            default() {
                return ''
            }
        }
    },
    data() {
        return {
            countries:[],
            country:'91',
            phone:'',
            phonenumber:''
        }
    },
    mounted() {

        const isoList = getCountries()

        const locale='en-US'
        for (const iso2 of isoList) {
            const displayNamesInstance  =new Intl.DisplayNames([locale], { type: 'region' });
            const name= displayNamesInstance.of(iso2);

            if (name) {
                try {
                    const dialCode = getCountryCallingCode(iso2)
                    this.countries.push({
                        country:iso2,
                        code:dialCode,
                        name:name
                    })
                } catch (error) {
                    console.error(`[MazPhoneNumberInput](getCountryCallingCode) ${error}`)
                }
            }
        }


        this.phonenumber=this.modelValue;


        try {
            phoneNumber=parsePhoneNumber("+"+this.phonenumber);
            this.country=phoneNumber.countryCallingCode;
            this.phone=phoneNumber.nationalNumber;
        } catch (error) {
            this.phone=this.phonenumber;
        }


    },
    methods:{
        validate(){

            try {
                phoneNumber=parsePhoneNumber("+"+this.country+this.phone);

                if(phoneNumber.isValid()){
                    this.$emit("change", this.country+this.phone);
                }
                else{
                    this.$emit("change", "");
                }

            } catch (error) {
                console.log(error);
                this.$emit("change", "");
            }
        }
    }
}
</script>

<style scoped>

</style>
